import { CustomerAccountDetailsType } from '../../customerAccountTransformSchema';
import { TYPOGRAPHY_STYLES, NOT_PROVIDED } from '../../constants';
import type { CustomerLookupResponseAccount } from 'packages/tackle-api/src/co-sell-msft/customerLookup';

// COMPONENTS
import { Tag, Button } from '@tackle-io/platform-ui';
import { Box } from 'vendor/material';
import { Typography, useTheme } from 'ui';
import { getAddressFromAccountDetails } from '../../helpers';

// ASSETS
import useStyles from './LinkedAccountItem.styles';

export default function LinkedAccountItem({
  account,
  onSelect,
}: {
  account: CustomerLookupResponseAccount;
  onSelect: (customerDetails: CustomerAccountDetailsType) => void;
}) {
  const theme = useTheme();
  const classes = useStyles();
  const accountDetails = account?.customerAccountDetails;
  const isMaccEligible = accountDetails?.msp_customermacceligibility === 'Yes';

  return (
    <Box
      width="100%"
      position="relative"
      className={classes.itemContainer}
      my={1}
    >
      <Box className={classes.itemHeader} p={2} mb={1}>
        <Typography style={{ ...TYPOGRAPHY_STYLES, fontWeight: 400 }}>
          {accountDetails?.name || NOT_PROVIDED}
        </Typography>
      </Box>
      <Box p={2}>
        <Box display="flex" flexDirection="row" alignItems="center">
          <Box>
            <Typography
              style={{
                ...TYPOGRAPHY_STYLES,
                fontSize: '12px',
                fontWeight: 600,
              }}
            >
              {getAddressFromAccountDetails({
                accountDetails: accountDetails,
              }) || NOT_PROVIDED}
            </Typography>
            <Typography
              style={{
                ...TYPOGRAPHY_STYLES,
                fontSize: '12px',
                fontWeight: 600,
              }}
              mt={1}
            >
              <strong>Microsoft ID: </strong>
              {accountDetails?.msp_accountnumber || NOT_PROVIDED}
            </Typography>
            {isMaccEligible && (
              <Tag className={classes.maccEligibleTag}>MACC</Tag>
            )}
          </Box>
          <Box display="block" position="absolute" right={theme.spacing(2)}>
            <Button
              appearance="primary"
              variant="outlined"
              onClick={() => onSelect(accountDetails)}
            >
              Add
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
